<template>
  <audio class="audio" controls="controls" :src="sound" ref="audio" v-show="false"></audio>
</template>

<script>
import sounds from '@/assets/tone.mp3';
export default {
  name: "myaudio",
  data(){
    return {
      sound:sounds
    }
  },
  methods:{
    play(){
      this.$refs.audio.currentTime = 0;
      this.$refs.audio.play();
    }
  }
}
</script>

<style scoped>

</style>
